import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'usimweb-radio-group',
    template: `
    <mat-radio-group (change)="viewChanges($event)" [(ngModel)]="default">
      <mat-radio-button
        class="row"
        *ngFor="let button of buttons"
        [value]="button.key"
        [matTooltip]="button.tooltip || ''"
      >
        {{ button.value }}
      </mat-radio-button>
    </mat-radio-group>
  `,
    standalone: false
})
export class RadioGroupComponent {
  @Input() default!: string | boolean;

  @Input() buttons!: { key: string | boolean; value: string; tooltip?: string }[];

  @Output() changes: EventEmitter<any> = new EventEmitter();

  public viewChanges(event: any) {
    this.changes.emit(event.value);
  }
}
